import { NgModel, ValidatorFn, NG_VALIDATORS, Validator, UntypedFormControl } from '@angular/forms';
import { Directive } from '@angular/core';
import { validateJuriNameFactory } from './validate-juri-name-factory';
@Directive({
  selector: '[juriName][ngModel]',
  providers: [
    { provide: NG_VALIDATORS, useExisting: JuriNameValidator, multi: true }
  ]
})
export class JuriNameValidator implements Validator {
  validator: ValidatorFn;
  constructor() {
    this.validator = validateJuriNameFactory();
  }
  validate(c: UntypedFormControl) {
    return this.validator(c);
  }
}
